import styles from './NotFound.module.css'
import Typewriter from '../TypeWritter/TypeWritter'

const NotFound = () => {
    return (
        <div className={styles.container}>
            <div className={styles.section}>
                <div className={styles.landing_page}>
                    <div className={styles.title}>
                        <div className={styles.title_blur}>
                            <span>404</span>
                            <span>404</span>
                        </div>
                    </div>
                    <div className={styles.info}>
                        <Typewriter
                            texts={['.Page_Not_Found', 'Are_You_Lost?']}
                            speed={100}
                            pause={1500}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NotFound
